<template>
  <Modal
    :modal-style="{ width: '500px' }"
    title="Attachments"
  >
    <div class="column main q-px-lg center">
      <div v-if="attachments.length">
        <UploadTable
          class="q-mb-md"
          :files="attachments"
          hide-upload
        />
      </div>
      <div
        v-else
        class="text-center"
      >
        No attachments
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

import UploadTable from "src/components/common/UploadTable.vue";

export default {
  name: "AttachmentsModal",
  components: {
    Modal,
    UploadTable,
  },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },
};
</script>
